<div class="flex flex-col">
  <div class="progress-bar mb-8">
    <div
      class="progress"
      [style.backgroundColor]="progressColor"
      [style.width.%]="progressPercentage"
    ></div>
  </div>
</div>
